<div *ngIf="!init" style="align-self: center;">
  <mat-spinner
    style="margin: auto;"
    color="primary"
    diameter="24"
  ></mat-spinner>
</div>
<div *ngIf="init" [ngClass]="displayListClass">
  <ul class="inpress-ul">
    <li
      *ngFor="
        let subProject of subProjectGroup.subProjects;
        let index = index;
        trackBy: trackById
      "
    >
      <span
        class="clickable project-popup-entry"
        (click)="displayChild(index)"
        >{{ subProject.popupDisplay }}</span
      >
    </li>
  </ul>
</div>
<ng-container
  *ngFor="
    let subProject of subProjectGroup.subProjects;
    let index = index;
    trackBy: trackById
  "
>
  <admin-planning-marker-project-info
    *ngIf="!hidePlannedProjects || !subProject.planned"
    [index]="index"
    [subProject]="subProject"
    [toggleDisplay]="toggleDisplay"
    [alwaysDisplay]="alwaysDisplay"
    [placerOptions]="placerOptions"
    [updatePlanValues]="updatePlanValues"
    [showSubmitPlanContent]="showSubmitPlanContent"
    (backPressed)="backPressed()"
    (subProjectPlanned)="subProjectPlanned($event)"
  ></admin-planning-marker-project-info>
</ng-container>
